<template>
  <el-config-provider :size="getGlobalComponentSize" :locale="zhCn">
    <router-view v-show="themeConfig.lockScreenTime > 1" />
    <Setings ref="setingsRef" v-show="themeConfig.lockScreenTime > 1" />
    <!-- 智能客服悬浮按钮 - 登录后显示，进件页面除外 -->
    <CustomerService v-if="showCustomerService" />
  </el-config-provider>
</template>

<script setup name="app">
import { defineAsyncComponent, computed, ref, onBeforeMount, onMounted, onUnmounted, nextTick, watch } from 'vue';
import { useRoute } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useTagsViewRoutes } from '@/stores/tagsViewRoutes';
import { useThemeConfig } from '@/stores/themeConfig';
import other from '@/utils/other';
import { Local, Session } from '@/utils/storage';
import mittBus from '@/utils/mitt';
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import {getDomainConfig} from "@/utils/domainConfig";

// 引入组件
const Setings = defineAsyncComponent(() => import('@/layout/navBars/breadcrumb/setings.vue'));
const CustomerService = defineAsyncComponent(() => import('@/components/CustomerService.vue'));

// 定义变量内容
const setingsRef = ref();
const route = useRoute();
const stores = useTagsViewRoutes();
const storesThemeConfig = useThemeConfig();
const { themeConfig } = storeToRefs(storesThemeConfig);

// 判断是否已登录 - 使用响应式 ref 以便在登录后能实时更新
const isLoggedIn = ref(!!Session.get('token'));

// 判断是否显示智能客服 - 登录后且非进件页面
const showCustomerService = computed(() => {
  return isLoggedIn.value && route.path !== '/mch/apply/list';
});

// 获取全局组件大小
const getGlobalComponentSize = computed(() => {
  return other.globalComponentSize();
});

// 设置初始化，防止刷新时恢复默认
onBeforeMount(() => {
  initDomainConfig();
});

// 初始化域名配置
const initDomainConfig = () => {
  const domain = window.location.hostname;
  const customConfig = getDomainConfig(domain);
  if (customConfig) {
    const currentThemeConfig = Local.get('themeConfig') || storesThemeConfig.themeConfig;
    currentThemeConfig.wartermarkText = customConfig.name;
    currentThemeConfig.globalTitle = customConfig.name;
    currentThemeConfig.icpNo = customConfig.icpNo;

    storesThemeConfig.setThemeConfig({ themeConfig: currentThemeConfig });
    Local.set('themeConfig', currentThemeConfig);
  }
};

// 页面加载时
onMounted(() => {
  nextTick(() => {
    mittBus.on('openSetingsDrawer', () => {
      setingsRef.value.openDrawer();
    });

    initDomainConfig();

    if (Local.get('themeConfig')) {
      storesThemeConfig.setThemeConfig({ themeConfig: Local.get('themeConfig') });
      document.documentElement.style.cssText = Local.get('themeConfigStyle');
    }

    if (Session.get('isTagsViewCurrenFull')) {
      stores.setCurrenFullscreen(Session.get('isTagsViewCurrenFull'));
    }
  });
});

onUnmounted(() => {
  mittBus.off('openSetingsDrawer', () => {});
});

watch(
    () => route.path,
    (newPath) => {
      other.useTitle();
      // 当路由变化时（如登录成功后跳转），重新检查登录状态
      isLoggedIn.value = !!Session.get('token');
    },
    {
      deep: true,
    }
);
</script>